import { render, staticRenderFns } from "./customerForm.vue?vue&type=template&id=35fe701e&scoped=true&"
import script from "./customerForm.vue?vue&type=script&lang=js&"
export * from "./customerForm.vue?vue&type=script&lang=js&"
import style0 from "./customerForm.vue?vue&type=style&index=0&id=35fe701e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fe701e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35fe701e')) {
      api.createRecord('35fe701e', component.options)
    } else {
      api.reload('35fe701e', component.options)
    }
    module.hot.accept("./customerForm.vue?vue&type=template&id=35fe701e&scoped=true&", function () {
      api.rerender('35fe701e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/partner/tab/customerForm.vue"
export default component.exports